"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectQuestionWidgetBase = void 0;
var QuestionWidgetBase_1 = require("./QuestionWidgetBase");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var journey_model_1 = require("@athena-portal/journey-model");
var SelectQuestionWidgetBase = exports.SelectQuestionWidgetBase = /** @class */ (function (_super) {
    __extends(SelectQuestionWidgetBase, _super);
    function SelectQuestionWidgetBase(props) {
        var _this = _super.call(this, props) || this;
        _this.state = Object.assign({
            serviceError: false,
            classifier: ""
        });
        return _this;
    }
    SelectQuestionWidgetBase_1 = SelectQuestionWidgetBase;
    /**
     * Component mounted - load dynamic data
     */
    SelectQuestionWidgetBase.prototype.componentDidMount = function () {
        if (this.getSetting(SelectQuestionWidgetBase_1.lookupNameSetting)) {
            this.fetchLookupValues();
        }
        else if (this.getSetting(SelectQuestionWidgetBase_1.selectItemsSetting)) {
            this.setState({
                lookupValues: this.getSetting(SelectQuestionWidgetBase_1.selectItemsSetting)
            });
        }
        else {
            throw new Error("Widget ".concat(this.props.question.name, " is not configured properly - one of the settings ").concat(SelectQuestionWidgetBase_1.lookupNameSetting, " or ").concat(SelectQuestionWidgetBase_1.selectItemsSetting, " should be set."));
        }
    };
    SelectQuestionWidgetBase.prototype.componentWillUnmount = function () {
        this.subscription && this.subscription.unsubscribe();
    };
    SelectQuestionWidgetBase.prototype.componentDidUpdate = function () {
        if (this.getSetting(SelectQuestionWidgetBase_1.lookupNameSetting)) {
            this.fetchLookupValues();
        }
    };
    SelectQuestionWidgetBase.prototype.fetchLookupValues = function () {
        var _this = this;
        var classifier = this.getLookupName();
        var fieldValue = this.getSetting(SelectQuestionWidgetBase_1.checkFieldValueSetting) ? this.getInteractionFieldValue() : undefined;
        if (this.canFetchLookupValues() && classifier !== this.state.classifier) {
            this.setState({ classifier: classifier });
            this.subscription && this.subscription.unsubscribe();
            this.subscription = this.lookupService.fetchLookupValues(classifier, "en-UK", fieldValue).subscribe(function (lookupValues) {
                _this.setState({
                    lookupValues: lookupValues
                });
            }, function () {
                _this.setState({
                    serviceError: true
                });
            });
        }
    };
    SelectQuestionWidgetBase.prototype.getLookupName = function () {
        return this.renderTemplate(this.getSetting(SelectQuestionWidgetBase_1.lookupNameSetting));
    };
    SelectQuestionWidgetBase.prototype.canFetchLookupValues = function () {
        return true;
    };
    SelectQuestionWidgetBase.prototype.getInteractionFieldValue = function () {
        var interactionFieldValue = this.bindFromField(this.props.question.interactionField);
        if (interactionFieldValue == null) {
            return undefined;
        }
        return interactionFieldValue;
    };
    var SelectQuestionWidgetBase_1;
    SelectQuestionWidgetBase.lookupNameSetting = "classifier";
    SelectQuestionWidgetBase.selectItemsSetting = "values";
    SelectQuestionWidgetBase.checkFieldValueSetting = "checkFieldValue";
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.LookupService),
        __metadata("design:type", Object)
    ], SelectQuestionWidgetBase.prototype, "lookupService", void 0);
    SelectQuestionWidgetBase = SelectQuestionWidgetBase_1 = __decorate([
        (0, journey_model_1.event)(journey_model_1.Event.onChange),
        (0, journey_model_1.settings)([
            { name: "classifier", type: journey_model_1.TypeDescriptions.Expression },
            { name: "values", type: journey_model_1.TypeDescriptions.KeyValuePairs },
            { name: "checkFieldValue", type: journey_model_1.TypeDescriptions.Boolean },
        ]),
        __metadata("design:paramtypes", [Object])
    ], SelectQuestionWidgetBase);
    return SelectQuestionWidgetBase;
}(QuestionWidgetBase_1.QuestionWidgetBase));
//# sourceMappingURL=SelectQuestionWidgetBase.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/widgets/input/SelectQuestionWidgetBase.js
// module id = 278
// module chunks = 0